"use strict";

exports.__esModule = true;
exports.KeyCode = exports.FieldTypeAttachmentUrls = void 0;
var FieldTypeAttachmentUrls = {
  '.docx?$': 'https://pipestyle.staticpipefy.com/images/file_type_thumbnails/doc.svg',
  '.pdf$': 'https://pipestyle.staticpipefy.com/images/file_type_thumbnails/pdf.svg',
  '.pptx?$': 'https://pipestyle.staticpipefy.com/images/file_type_thumbnails/ppt.svg',
  '.txt$': 'https://pipestyle.staticpipefy.com/images/file_type_thumbnails/txt.svg',
  '.xlsx?$': 'https://pipestyle.staticpipefy.com/images/file_type_thumbnails/xls.svg',
  '.zip$': 'https://pipestyle.staticpipefy.com/images/file_type_thumbnails/zip.svg',
  '.(ogv|ogg|avi|mov|qt|wmv|mp4|m4v|mpg|mp2|mpeg|mpe|mpv)$': 'https://pipestyle.staticpipefy.com/images/file_type_thumbnails/video.svg',
  "default": 'https://pipestyle.staticpipefy.com/images/file_type_thumbnails/file.svg'
};
exports.FieldTypeAttachmentUrls = FieldTypeAttachmentUrls;
var KeyCode = {
  Escape: 27,
  ArrowLeft: 37,
  ArrowRight: 39
};
exports.KeyCode = KeyCode;